let ownedOverlayCount = 0

export function acquireGlobalOverlayOwnership() {
  ownedOverlayCount += 1
  let released = false

  return () => {
    if (released) return
    released = true
    ownedOverlayCount = Math.max(0, ownedOverlayCount - 1)
  }
}

export function shouldClearGlobalOverlay(config) {
  return ownedOverlayCount === 0 && !config?.preserveGlobalOverlay
}
